/* eslint-disable no-console */
import {
  keySecureBusiness,
  provinceAlias,
  CONSTANT
} from '../components/utils/constant';

/**
 * it returns updated payload with new properties 'shouldHideEasyPayments' and 'shouldSendDataToAdtDashboard'
 * based on province type and product selection
 * @param {Object} payload - the order information being sent to API
 * @returns {Object} updatedPayload - updated payload of order info with new properties
 */
const updatePayloadIfEasyPaymentsShouldHide = payload => {
  const {
    KEYS: {
      CHANNELS: {
        TAG_BC,
        TAG_AB,
        ELITE_PROMOTIONS_AND_MARKETING_INC,
        EVOLUTION_CLOUD_INC,
        INSTINCTIVE_BUSINESS_TECHNOLOGY_INC,
        TECH23_SOLUTIONS_INC,
        OUTPUT_INC
      }
    }
  } = CONSTANT;

  let updatedPayload = { ...payload };
  try {
    const {
      productSelection = [],
      parsedProvince = '',
      loggedInUserDetail: { channels }
    } = payload;
    const userChannels = channels.map(item => item.name);
    // const province = parseProvince(serviceAddress);
    const province = localStorage.getItem('province') || parsedProvince;
    const { Quebec, Alberta, British_Columbia } = provinceAlias;
    if (province) {
      // const sendDataToADT =
      //   province === Alberta || province === British_Columbia;

      // // === Handle flag for send Data to ADT === //
      // if (
      //   sendDataToADT ||
      //   userChannels.some(channelValue =>
      //     [
      //       TAG_BC,
      //       TAG_AB,
      //       ELITE_PROMOTIONS_AND_MARKETING_INC,
      //       EVOLUTION_CLOUD_INC,
      //       INSTINCTIVE_BUSINESS_TECHNOLOGY_INC,
      //       TECH23_SOLUTIONS_INC,
      //       OUTPUT_INC
      //     ].includes(channelValue)
      //   )
      // ) {
      //   updatedPayload = {
      //     ...updatedPayload,
      //     shouldSendDataToAdtDashboard: false
      //   };
      // } else if (productSelection.includes(keySecureBusiness)) {
      //   updatedPayload = {
      //     ...updatedPayload,
      //     shouldSendDataToAdtDashboard: true
      //   };
      // } else {
      //   updatedPayload = {
      //     ...updatedPayload,
      //     shouldSendDataToAdtDashboard: false
      //   };
      // }

      updatedPayload = {
        ...updatedPayload,
        shouldSendDataToAdtDashboard: false
      };
    }
  } catch (err) {
    updatedPayload = { ...payload };
  }
  return updatedPayload;
};

export { updatePayloadIfEasyPaymentsShouldHide };
